// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DHNRSpe{display:grid;grid-template-columns:1fr 1fr;margin-top:1em;gap:.5em}@media(max-width: 599px){.DHNRSpe{margin-top:0;padding:1em 1.5em 1.5em;border-radius:0 0 1em 1em;background:#fff}}.Whf0VtD:nth-child(even),.DHNRSpe .Whf0VtD:nth-child(even){margin-left:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `DHNRSpe`,
	"skeleton": `Whf0VtD`
};
export default ___CSS_LOADER_EXPORT___;
